import styled from 'styled-components';
import { space } from 'shared';

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.white};
  padding: ${space(40)};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .avatar {
    cursor: pointer;
  }
`;

export const ErrorText = styled.div`
  margin-top: ${space(30)};
  color: ${({ theme }) => theme.errorColor};
`;
